import Vue from 'vue'
import { format, getDay } from 'date-fns'
import _ from 'lodash'
import { i18n } from '@/i18n'
import { formatYMDHMS } from '@/utils/formatTime'
const _replace = _.curry((reg, format, value) => value.replace(reg, format))
const reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})?/
// eslint-disable-next-line
const formatYMD2 = _replace(reg, '$1-$2-$3')
const formatHMS2 = _replace(reg, '$4:$5:$6')
// 日期格式
Vue.filter('format_YMDHMS', formatYMDHMS)
// 时分秒
Vue.filter('format_HMS', (value) => {
  if (!value) return ''
  if (value.toString().length === 10) value *= 1000
  return format(new Date(value), 'HH:mm:ss')
})
// 字符串日期格式, value为"20180126123356"
Vue.filter('format_YMD2', (value) => {
  if (!value) return ''
  return formatYMD2(value)
})
Vue.filter('format_HMS2', (value) => {
  if (!value) return ''
  return formatHMS2(value)
})
// 字符串日期格式, value为"20180126123356"
Vue.filter('format_Y-M-D', (value) => {
  if (!value) return ''
  if (value.toString().length === 10) value *= 1000
  return format(new Date(value), 'yyyy-MM-dd')
})

Vue.filter('format_Y-M', (value) => {
  if (!value) return ''
  if (value.toString().length === 10) value *= 1000
  return format(new Date(value), 'yyyy-MM')
})

// 字符串日期格式, value为"20180126123356"
Vue.filter('format_YMD', (value) => {
  if (!value) return ''
  return format(new Date(value), 'yyyy年MM月dd日')
})
// 日历模块中 周格式, value为"2018/1/1"
Vue.filter('formatWeek', (value, type) => {
  let dateSplit = value.split(type)
  let month = dateSplit[1] < 9 ? `0${dateSplit[1]}` : dateSplit[1]
  let day = dateSplit[2] < 10 ? `0${dateSplit[2]}` : dateSplit[2]
  let weekDay = getDay(value)
  let week = [
    i18n.t('common_sun'),
    i18n.t('common_mon'),
    i18n.t('common_tues'),
    i18n.t('common_wed'),
    i18n.t('common_thur'),
    i18n.t('common_fri'),
    i18n.t('common_sat'),
  ][weekDay]
  return `${week} ${month}/${day}`
})
// 秒转化为时分秒
Vue.filter('formatSecond', (d) => {
  d = Number(d)
  const h = Math.floor(d / 3600)
  const m = Math.floor((d % 3600) / 60)
  const s = Math.floor((d % 3600) % 60)

  const hDisplay = h > 0 ? h + i18n.t('common_hour') : ''
  const mDisplay = m > 0 ? m + i18n.t('common_minute') : ''
  const sDisplay = s > 0 ? s + i18n.t('common_second') : ''
  return hDisplay + mDisplay + sDisplay
})

// 秒数转换为 xx天xx小时xx分钟xx秒
Vue.filter('formatDuration', (seconds) => {
  const value = Number(seconds)
  if (Number.isNaN(value) || value <= 0) return 0
  const minute = 60
  const hour = minute * 60
  const day = hour * 24
  const year = day * 365

  let years = Math.floor(seconds / year)
  let days = Math.floor((seconds % year) / day)
  let hours = Math.floor((seconds % day) / hour)
  let minutes = Math.floor((seconds % hour) / minute)
  let secs = Math.floor(seconds % minute)

  const parts = []
  if (years > 0) parts.push(`${years}${i18n.t('common_year')}`)
  if (years > 0 || days > 0) parts.push(`${days}${i18n.t('common_day')}`)
  if (years > 0 || days > 0 || hours > 0) parts.push(`${hours}${i18n.t('common_hour')}`)
  if (years > 0 || days > 0 || hours > 0 || minutes > 0) parts.push(`${minutes}${i18n.t('common_minute')}`)
  if (years > 0 || days > 0 || hours > 0 || minutes > 0 || secs > 0) parts.push(`${secs}${i18n.t('common_second')}`)
  return parts.join('')
})

// 将 "2026-02-02 17:24:52" 或时间戳格式转换为 ISO 格式 "2026-02-01T16:00:00.000Z"
Vue.filter('format_ISO', (value) => {
  if (!value) return ''
  // 如果已经是 ISO 格式，直接返回
  if (typeof value === 'string' && value.includes('T') && value.includes('Z')) {
    return value
  }
  let timestamp = value
  if (typeof value === 'number' || (typeof value === 'string' && /^\d{10,13}$/.test(value))) {
    timestamp = Number(value)
    // 如果是10位时间戳（秒级），转换为13位（毫秒级）
    if (timestamp.toString().length === 10) {
      timestamp = timestamp * 1000
    }
  }
  const date = new Date(timestamp)
  return date.toISOString()
})
